<template>
  <div
    :key="event.end.toString()"
    :class="[
      'event-container',
      event.isError ? 'error-item' : ''
    ]"
    @drop="onCustomDrop && onCustomDrop($event, event)"
    @dragover="onCustomDragOver && onCustomDragOver($event)"
    @dragleave="onCustomDragLeave && onCustomDragLeave($event)"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <div
      :title="event.title"
      class="event-header"
    >
      <div
        class="title-recurrent"
        :class="{ 'has-close-button': isDayMode && !event.isPrevious }"
      >
        <div
          class="vuecal__event-title"
          :title="event.title"
        >
          {{ event.title }}
        </div>
        <div
          v-if="event.recurring"
          class="recurrent-wrap"
        >
          <inline-svg
            :src="iconRecurrent"
            class="svg-icon"
          >
          </inline-svg>
        </div>
      </div>

      <div
        v-show="isDayMode && !event.isPrevious"
        class="icon-close-wrapper"
      >
        <inline-svg
          :src="iconClose"
          class="svg-icon"
          data-type="remove"
          @click="onRemoveClick && onRemoveClick(event)"
        >
        </inline-svg>
      </div>
    </div>
    <small class="vuecal__event-time">
      <div
        v-if="isDayMode && (event.daysCount > 1)"
        class="multiple-day"
      >
        multi-day
      </div>
      <span>
        {{ event.start.formatTime("HH:mm") }} - {{ event.end.formatTime("HH:mm") }}
      </span><br />
    </small>
  </div>
</template>

<script>
export default {
  name: 'ScheduleEventItem',
  props: {
    event: {
      type: Object,
      required: true,
    },
    isDayMode: {
      type: Boolean,
      default: false,
    },
    iconClose: {
      type: String,
      required: true,
    },
    iconRecurrent: {
      type: String,
      required: true,
    },
    onCustomDrop: {
      type: Function,
      default: null,
    },
    onCustomDragOver: {
      type: Function,
      default: null,
    },
    onCustomDragLeave: {
      type: Function,
      default: null,
    },
    onEventMouseEnter: {
      type: Function,
      default: null,
    },
    onEventMouseLeave: {
      type: Function,
      default: null,
    },
    onRemoveClick: {
      type: Function,
      default: null,
    },
  },
  methods: {
    handleMouseEnter(e) {
      // Pre-filter: only in Day mode, not previous events
      if (!this.isDayMode || this.event.isPrevious) return;
      // Only trigger parent if the event block looks truncated
      const eventRoot = e.target.closest('.vuecal__event');
      if (!eventRoot) return;
      if (this.isTruncatedEvent(eventRoot)) {
        if (typeof this.onEventMouseEnter === 'function') {
          this.onEventMouseEnter(e, this.event);
        }
      }
    },
    handleMouseLeave(e) {
      if (typeof this.onEventMouseLeave === 'function') {
        this.onEventMouseLeave(e);
      }
    },
    isTruncatedEvent(eventEl) {
      try {
        const h = eventEl.clientHeight;
        const contentEl = eventEl.querySelector('.event-container');
        const overflowing = contentEl && contentEl.scrollHeight > contentEl.clientHeight;
        return h < 26 || overflowing;
      } catch (err) {
        return false;
      }
    },
  },
};
</script>

<style scoped>
  .event-container {
    cursor: pointer;
    height: 100%;
  }

  .event-header {
    display: flex;
    justify-content: space-between;
  }

  .title-recurrent {
    display: flex;
    width: calc(100% - 15px);
  }

  .title-recurrent.has-close-button{
    width: calc(100% - 35px);
  }

  .recurrent-wrap {
    margin-left: 10px;
  }

  .multiple-day {
    background-color: #2491cf;
    border: 1px solid #2491cf;
    border-radius: 4px;
    padding: 2px 5px;
    width: 60px;
    text-align: center;
  }
</style>
